import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { DesktopButton } from 'shared/components/BannerAll';
import SparepartItem from 'desktop/components/SparepartItem/SparepartItem';
import SparepartDefaultItem from 'desktop/components/SparepartDefaultItem/SparepartDefaultItem';
import s from './PartList.css';

class PartList extends React.Component {
  static propTypes = {
    parts: PropTypes.arrayOf(PropTypes.shape()),
    selectedCurrency: PropTypes.shape({}).isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  };
  static defaultProps = {
    parts: [],
  };
  render() {
    const { parts, selectedCurrency, title } = this.props;

    return (
      <div className={s.root}>
        {parts && parts.length > 0 ? (
          parts.map((advert, i) => (
            <div key={advert.id}>
              {i === 6 && <DesktopButton />}
              {advert.is_default ? (
                <SparepartDefaultItem
                  advert={advert}
                  selectedCurrency={selectedCurrency}
                  title={title}
                  isSpare
                />
              ) : (
                <SparepartItem
                  advert={advert}
                  selectedCurrency={selectedCurrency}
                  title={title}
                  isSpare
                />
              )}
            </div>
          ))
        ) : (
          <div className={s.defaultText}>
            <FormattedMessage id={'По Вашему запросу ничего не найдено'} />
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(PartList);



// WEBPACK FOOTER //
// ./src/desktop/routes/spareparts/components/PartList/PartList.js